export type LocaleCode = "en-GB";

export type LocaleConfig = {
  code: LocaleCode;
  label: string;
  htmlLang: string;
  dir: "ltr" | "rtl";
};

export const LOCALES: LocaleConfig[] = [
  { code: "en-GB", label: "English (UK)", htmlLang: "en-GB", dir: "ltr" },
];

export const DEFAULT_LOCALE: LocaleCode = "en-GB";

export type CurrencyCode = "GBP" | "EUR" | "USD" | "AED" | "EGP";

export const SUPPORTED_CURRENCIES: ReadonlyArray<CurrencyCode> = [
  "GBP",
  "EUR",
  "USD",
  "AED",
  "EGP",
];

export const CURRENCY_FRACTION_DIGITS: Record<CurrencyCode, number> = {
  GBP: 0,
  EUR: 0,
  USD: 0,
  AED: 0,
  EGP: 0,
};
